import React, { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import './Layout.css';

interface LayoutProps {
  children?: ReactNode;
  onStartAnalysis?: () => void; // For Footer
  canStartAnalysis?: boolean;  // For Footer
  currentStep: 'Evaluation' | 'Analysis' | 'Action'; // For Header
  headerContent?: {
    iconSrc: string;
    iconAlt: string;
    title: string;
    subtitle: string;
  };
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  onStartAnalysis, 
  canStartAnalysis, 
  currentStep,
  headerContent = {
    iconSrc: '/portfolio_management_icon.png',
    iconAlt: 'Portfolio Icon',
    title: 'Portfolio Management',
    subtitle: 'Get the latest updates, news, and price information\nSelect a project you\'re interested in, and we\'ll provide you with the latest information'
  } 
}) => {
  return (
    <div className="layout">
      <Header 
        currentStep={currentStep} 
        iconSrc={headerContent.iconSrc}
        iconAlt={headerContent.iconAlt}
        title={headerContent.title}
        subtitle={headerContent.subtitle}
      />
      <div className="layout-content">
        {children}
      </div>
      <Footer onStartAnalysis={onStartAnalysis} canStartAnalysis={canStartAnalysis} />
    </div>
  );
};

export default Layout;
